<template>
    <div class="order-detail-table">

        <dl v-if="orderNumber">
            <dt>
                <label class="ec-label required">注文番号</label>
            </dt>
            <dd>{{ orderNumber }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">御社名</label>
            </dt>
            <dd>{{ orderHistory.orderCompanyName }}</dd>
        </dl>

        <dl v-if="orderHistory.familyName&&orderHistory.firstName">
            <dt>
                <label class="ec-label required">氏名</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.familyName }} {{ orderHistory.firstName }}</dd>
        </dl>

        <dl v-if="orderHistory.userName">
            <dt>
                <label class="ec-label required">氏名</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.userName }}</dd>
        </dl>

        <dl>
            <dt>
                <label class="ec-label required">メールアドレス</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.userEmail }}</dd>
        </dl>

<!--        <dl v-if="!isStockCheckOnly">-->
<!--            <dt>-->
<!--                <label class="ec-label required">振込名義</label>-->
<!--            </dt>-->
<!--            <dd>{{ orderHistory.paymentName }}</dd>-->
<!--        </dl>-->

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">連絡先電話番号</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.userPhone }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">住所</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.orderUserAddress.allAddress }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">ご利用日</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ dateFormat(orderHistory.usageDate, 'YYYY年MM月DD日(dd)') }}</dd>
        </dl>

        <dl>
            <dt>
                <label class="ec-label required">利用先都道府県</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.usagePrefecture }}</dd>
        </dl>

<!--        <dl v-if="!isStockCheckOnly">-->
<!--            <dt>-->
<!--                <label class="ec-label required">ご利用時間</label>-->
<!--            </dt>-->
<!--            <dd>{{ orderHistory.usageTime }}</dd>-->
<!--        </dl>-->

<!--        <dl v-if="!isStockCheckOnly">-->
<!--            <dt>-->
<!--                <label class="ec-label required">使用予定人数</label>-->
<!--            </dt>-->
<!--            <dd>{{ orderHistory.plannedNumber }}人</dd>-->
<!--        </dl>-->

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">ご利用用途</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.usageNameText }}</dd>
        </dl>


        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">
                    {{ CheckoutService.getUsageDetailFormLabel(orderHistory.usageName) }}
                </label>
                <span v-if="orderHistory.usageName != USAGE_NAME_OTHER" class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.usageDetail }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">納品先住所</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.orderDeliveryAddress.allAddress }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">納品先電話番号</label>
            </dt>
            <dd>{{ orderHistory.deliveryTargetPhoneNumber }}</dd>
        </dl>

        <dl>
            <dt>
                <label class="ec-label required">納品希望日</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ dateFormat(orderHistory.deliveryDate, 'YYYY年MM月DD日(dd)') }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">納品時間指定希望</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.deliveryTimeSpecifiedName }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">納品方法</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.deliveryMethodName }}</dd>
        </dl>

        <dl v-if="orderHistory.deliveryTimeDetail && !isStockCheckOnly">
            <dt>
                <label class="ec-label required">希望時間</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.deliveryTimeDetailName }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly && orderHistory.deliveryMethod === DELIVERY_METHOD_DELIVER_CHARTER">
            <dt>
                <label class="ec-label required">搬入サポート</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.carriedSupportDisplay(orderHistory.carriedSupport) }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">納品担当者名</label>
            </dt>
            <dd>{{ orderHistory.deliveryPersonName }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">納品担当者連絡先</label>
            </dt>
            <dd>{{ orderHistory.deliveryPersonTel }}</dd>
        </dl>

<!--        <dl v-if="!isStockCheckOnly">-->
<!--            <dt>-->
<!--                <label class="ec-label required">その他注意事項</label>-->
<!--            </dt>-->
<!--            <dd style="word-break: break-word; white-space: break-spaces;">{{ orderHistory.deliveryTargetOther }}</dd>-->
<!--        </dl>-->

        <dl>
            <dt>
                <label class="ec-label required">返却発送日</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ dateFormat(orderHistory.returnDate, 'YYYY年MM月DD日(dd)') }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">返却方法</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.returnMethodName }}</dd>
        </dl>

        <dl v-if="CheckoutService.isShowReturnTimeDetailForm(orderHistory.returnTimeSpecified) && !isStockCheckOnly">
            <dt>
                <label class="ec-label required">返却時間指定希望</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.returnTimeSpecifiedName }}</dd>
        </dl>

        <dl v-if="orderHistory.returnTimeDetail && !isStockCheckOnly">
            <dt>
                <label class="ec-label required">希望時間</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.returnTimeDetailName }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly && orderHistory.returnMethod === RETURN_METHOD_DELIVER_CHARTER">
            <dt>
                <label class="ec-label required">搬出サポート</label><span class="ec-required">必須</span>
            </dt>
            <dd>{{ orderHistory.carriedSupportDisplay(orderHistory.carryOutSupport) }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">返却担当者名</label>
            </dt>
            <dd>{{ orderHistory.returnPersonName }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">返却担当者連絡先</label>
            </dt>
            <dd>{{ orderHistory.returnPersonTel }}</dd>
        </dl>

<!--        <dl v-if="!isStockCheckOnly">-->
<!--            <dt>-->
<!--                <label class="ec-label required">その他注意事項</label>-->
<!--            </dt>-->
<!--            <dd style="word-break: break-word; white-space: break-spaces;">{{ orderHistory.returnTargetOther }}</dd>-->
<!--        </dl>-->

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">備考</label>
            </dt>
            <dd style="word-break: break-word; white-space: break-spaces;">{{ orderHistory.remarks }}</dd>
        </dl>

        <dl v-if="!isStockCheckOnly">
            <dt>
                <label class="ec-label required">クーポン</label>
            </dt>
            <dd>{{ orderHistory.couponId ? orderHistory.coupon.name : 'なし' }}</dd>
        </dl>
    </div>
</template>

<script>

import OrderHistory, {
    DELIVERY_METHOD_DELIVER_CHARTER,
    RETURN_METHOD_DELIVER_CHARTER,
    USAGE_NAME_OTHER
} from "../../models/OrderHistory";
import {dateFormat} from "../../utility/dateUtility"
import CheckoutService from '../../services/CheckoutService'

export default {
    name: 'order-detail-table',

    data() {
        return {
            dateFormat,
            CheckoutService,
            USAGE_NAME_OTHER,
            DELIVERY_METHOD_DELIVER_CHARTER,
            RETURN_METHOD_DELIVER_CHARTER,
        }
    },

    props: {
        orderNumber: {
            type: String,
            default: '',
        },
        orderHistory: {
            type: OrderHistory,
            required: true,
        },
        isStockCheckOnly: {
            type: Number,
            default: 0,
        }
    },

    created() {},

    mounted() {},

    methods: {},

    components: {}
}
</script>

<style lang="scss" scoped>
.order-detail-table {
    width: 100%;
    border-top: 1px dotted #ccc;
    margin-bottom: 60px;

    dl {
        flex-wrap: nowrap;
        padding: 15px 0 4px;
        display: flex;
        border-bottom: 1px dotted #ccc;
        margin: 0;
    }

    dt {
        padding-top: 14px;
        width: 30%;
    }

    dd {
        width: 70%;
        line-height: 3;
    }


    .ec-label {
        display: inline-block;
        font-weight: bold;
        margin-bottom: 5px;
    }
    .ec-required {
        margin-left: 1em;
        color: #DE5D50;
        font-size: 12px;
        font-weight: normal;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/order/OrderDetailTable.vue